import React from "react";
import { Table } from "react-bootstrap";
function GstSummary({ items }) {
  const gsts = {};
  const gst_types = items[0].gst_breakup.map((gst) => gst.type);
  for (let i = 0; i < items.length; i++) {
    if (gsts[items[i].gst_rate]) {
      //   gsts[items[i].gst_rate] = [
      //     ...gsts[items[i].gst_rate],
      //     ...items[i].gst_breakup,
      //   ];
      const gst = { ...gsts[items[i].gst_rate] };
      gst.taxable = gst.taxable + items[i].taxable_amount;
      for (let j = 0; j < items[i].gst_breakup.length; j++) {
        const child_gst = { ...gst[items[i].gst_breakup[j].type] };
        gst[items[i].gst_breakup[j].type] = {
          ...items[i].gst_breakup[j],
          amount: child_gst.amount + items[i].gst_breakup[j].amount,
        };
      }
      gsts[items[i].gst_rate] = gst;
    } else {
      const gst = { taxable: items[i].taxable_amount };
      for (let j = 0; j < items[i].gst_breakup.length; j++) {
        gst[items[i].gst_breakup[j].type] = { ...items[i].gst_breakup[j] };
      }
      // gsts[items[i].gst_rate] = items[i].gst_breakup.map((gst) => {
      // return { taxable: items[i].taxable_amount, ...gst };
      gsts[items[i].gst_rate] = gst;
    }
  }
  console.log(gsts);
  return (
    <div className="table-responsive">
      <Table bordered style={{ fontSize: "10px" }} className="text-end">
        <thead>
          <tr>
            <th className="text-center" colSpan={gst_types.length * 2 + 2}>
              GST Summary
            </th>
          </tr>
          <tr>
            <th>GST %</th>
            <th>Taxable</th>
            {gst_types.map((type, index) => (
              <React.Fragment key={index}>
                <th>{`${type} Tax%`}</th>
                <th>{`${type} Tax Amt`}</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(gsts).map((gst, index) => (
            <tr key={index}>
              <td>{gst[0]}%</td>
              <td>{gst[1].taxable}</td>
              {gst_types.map((type, index) => (
                <React.Fragment key={index}>
                  <td>{gst[1][type].percentage}</td>
                  <td>{gst[1][type].amount}</td>
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
export default GstSummary;
